import { autoUpdate, flip, offset, shift } from '@floating-ui/react'

/**
 * Custom Floating UI config for react-datepicker when the calendar is portaled
 * to `document.body` (modals / scrolling detail pages).
 */
export const PORTALED_DATEPICKER_POPPER_PROPS = {
  strategy: 'fixed' as const,
  whileElementsMounted: autoUpdate,
}

export const PORTALED_DATEPICKER_POPPER_MODIFIERS = [
  offset(10),
  flip({
    mainAxis: false,
    crossAxis: true,
    padding: 12,
    rootBoundary: 'viewport',
  }),
  shift({ padding: 12, crossAxis: true }),
]
